<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
@if (isDataChanged) {
  <div class="save">
    <button (click)="saveWorksheet()" mat-raised-button color="primary">
      SAVE
    </button>
  </div>
}

@if (showTable) {
  <div class="native-soil-wrapper" [ngClass]="{ 'with-save-button': isDataChanged }">
    <div class="n-tab-container">
      <div class="n-tab" [ngClass]="{ 'tube-w': !isBulk }">
        <mat-tab-group animationDuration="0" (selectedTabChange)="onTabChanged($event)">
          @if (isBulk) {
            <mat-tab
              label="As Received M/C">
            </mat-tab>
          }
          @if (isBulk && moistureWorksheets.length > 0) {
            <mat-tab
              [disabled]="!instructionConfirmed"
              label="Moisture Conditioning Sheet">
            </mat-tab>
          }
          @if (isBulk && proctorWorksheets.length > 0) {
            <mat-tab
              [disabled]="!instructionConfirmed"
              label="Single Proctor">
            </mat-tab>
          }
          @if (workSheets.length > 0) {
            <mat-tab
              [disabled]="!instructionConfirmed"
              label="Worksheet">
            </mat-tab>
          }
        </mat-tab-group>
      </div>
    </div>
    <section class="mt-3">
      <div class="native-table-container">
        @if (dataSource.length === 0) {
          <div class="no-tasks-assigned-container">
            <h1>{{ noTasksMessage }}</h1>
          </div>
        }
        @if (dataSource.length > 0) {
          <mat-table
            #table
            [dataSource]="dataSource"
            id="mat-t"
            class="mat-elevation-z8"
            aria-describedby="listOfWorksheets"
            cdkDropList
            (cdkDropListDropped)="dragDrop($event)"
            [cdkDropListDisabled]="dragDisabled"
            >
            <mat-header-row *matHeaderRowDef="displayedColumns.concat('action', 'sort'); sticky: true"></mat-header-row>
            <mat-row
              *matRowDef="let row; let i = index; columns: displayedColumns.concat('action', 'sort')"
              [class.bold-bottom-border]="isLastRowOfSample(row, i)"
              [ngClass]="{ 'gray-zebra': row.sequence % 2 !== 0 }"
              cdkDrag
              [cdkDragData]="row"
            ></mat-row>
            @for (columnName of displayedColumns; track columnName) {
              <ng-container [matColumnDef]="columnName">
                <mat-header-cell
                  class="header-text"
                  *matHeaderCellDef
                  [matTooltip]="getTooltipText(columnName)"
                  >
                  @if (columnName === 'select' && userService.roleCheck(['Admin','Manager'])) {
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="masterToggle()"
                      [checked]="isAllSelected()"
                      [indeterminate]="isIndeterminate()">
                    </mat-checkbox>
                  } @else {
                    <span [innerHTML]="getDisplayName(columnName)"></span>
                  }
                </mat-header-cell>
                <mat-cell
                  *matCellDef="let row"
                  class="row-cell"
                  [attr.rowspan]="getSpan(row, columnName)"
                  >
                  <div [style.visibility]="isHidden(row, columnName) ? 'hidden' : 'visible'">
                    @if (columnName === 'select' && userService.roleCheck(['Admin','Manager']) && showCheckboxIfInParent(row)) {
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelection(row);"
                        [checked]="selection.selected.includes(row)">
                      </mat-checkbox>
                    }
                    @if (columnName === 'sampleId') {
                      <div class="sampleid">
                        <span class="col-width-100 sp" [matTooltip]="row.sampleId" matTooltipClass="custom-tooltip">
                          {{ row.sampleId | truncate : 57 }}
                        </span>
                      </div>
                    }
                    @if (columnName === 'clientDescription') {
                      <div class="sampleid">
                        <span class="col-width-100 sp" [attr.title]="row.clientDescription" matTooltipClass="custom-tooltip">
                          {{ row.clientDescription | truncate : 57 }}
                        </span>
                      </div>
                    }
                    @if (columnName === 'reUse') {
                      @if (row.reUse) {
                        <img alt="reuse" src="../../../../../assets/icons/Refresh.svg" />
                      }
                    }
                    @if (columnName === 'status') {
                      @if (row.status) {
                        <img alt="check" src="../../../../assets/icons/Check.svg" />
                      }
                      @if (!row.status) {
                        <img alt="icon" src="../../../../assets/icons/table icon.svg" />
                      }
                    }
                    @if (
                      columnName !== 'status' &&
                      columnName !== 'sampleId' &&
                      columnName !== 'clientDescription' &&
                      columnName !== 'reUse'
                      ) {
                      <span
                        >
                        {{ getRowDataByKey(row, columnName) }}
                      </span>
                    }
                  </div>
                </mat-cell>
              </ng-container>
            }
            <!-- Action Column -->
            <ng-container matColumnDef="action" stickyEnd>
              <mat-header-cell class="header-text" *matHeaderCellDef></mat-header-cell>
              <mat-cell *matCellDef="let row">
                @if (enableActionMenu(row)) {
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                }
                <mat-menu class="dashboard-menu" #menu="matMenu" yPosition="below" xPosition="after">
                  @if (userService.roleCheck(['Manager', 'Labtech', 'Admin']) && row.parentRow) {
                    <button
                      mat-menu-item
                      (click)="assignTo(row)"
                      [disabled]="!tabAssign"
                      >
                      <span class="menu-text">
                        <img src="/assets/icons/User-multiple.svg" alt="File" /> &nbsp; Assign To
                      </span>
                    </button>
                  }
                  @if (showWeightsAndMoisturesButton && userService.roleCheck(['Manager', 'Admin']) && row.parentRow && !isMultipleSelected(row)) {
                    <button
                      mat-menu-item
                      (click)="setWeightnTests(row)"
                      >
                      <span class="menu-text">
                        <img src="/assets/icons/settings-icon.svg" alt="Worksheet" /> &nbsp; Set Weights and M/C
                      </span>
                    </button>
                  }
                  @if (checkEnableOpentTechWorkSheet && userService.roleCheck(['Manager', 'Admin']) && !isMultipleSelected(row)) {
                    <button
                      mat-menu-item
                      (click)="editWorksheet(row)"
                      >
                      <span class="menu-text">
                        <img src="/assets/icons/New-window-1.svg" alt="Worksheet" /> &nbsp; Open Tech Worksheet
                      </span>
                    </button>
                  }
                  @if (!checkEnableOpentTechWorkSheet && userService.roleCheck(['Manager', 'Admin']) && !isMultipleSelected(row)) {
                    <button
                      mat-menu-item
                      [disabled]="enableOpenTecWorksheet($safeNavigationMigration(row?.status), $safeNavigationMigration(row?.assignedTo)) || checkForEditEnable(row)"
                      (click)="editWorksheet(row)"
                      >
                      <span class="menu-text">
                        <img src="/assets/icons/New-window-1.svg" alt="Worksheet" /> &nbsp; Open Tech Worksheet
                      </span>
                    </button>
                  }
                  @if (userService.roleCheck(['Labtech']) && !isMultipleSelected(row)) {
                    <button
                      mat-menu-item
                      [disabled]="(row.status && userService.roleCheck(['Labtech'])) || checkForEditEnable(row)"
                      (click)="editWorksheet(row)"
                      >
                      <span class="menu-text">
                        <img src="/assets/icons/New-window-1.svg" alt="Worksheet" /> &nbsp; Open Tech Worksheet
                      </span>
                    </button>
                  }
                  @if (userService.roleCheck(['Manager', 'Admin']) && row.parentRow && !isMultipleSelected(row)) {
                    <button
                      mat-menu-item
                      (click)="deleteWorksheet(row.id)"
                      >
                      <span class="menu-text">
                        <img src="/assets/icons/Delete.svg" alt="Delete-icon" /> &nbsp; Delete Row
                      </span>
                    </button>
                  }
                </mat-menu>
              </mat-cell>
            </ng-container>
            <!-- Sort Column -->
            <ng-container matColumnDef="sort" stickyEnd>
              <mat-header-cell
                class="header-text"
                [ngClass]="{ 'hidden-column': shouldHideSortColumn() }"
                *matHeaderCellDef
              ></mat-header-cell>
              <mat-cell
                [ngClass]="{ 'hidden-column': shouldHideSortColumn() }"
                *matCellDef="let row"
                >
                @if (userService.roleCheck(['Manager', 'Admin']) && row.parentRow) {
                  <button
                    (mousedown)="dragDisabled = false"
                    mat-icon-button
                    >
                    <mat-icon class="dragCursor">drag_indicator</mat-icon>
                  </button>
                }
              </mat-cell>
            </ng-container>
          </mat-table>
        }
      </div>
    </section>
  </div>
}
